import Tooltip from '@components/Tooltips/Tooltip';
import styled from '@emotion/styled';
import { mq } from '@styles/helpers';
import { Devices } from '@styles/tokens';

export const CardHeader = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr 1fr;
  ${mq(Devices.desktop)}{
    grid-template-columns: 1fr 1fr;
  }
  ${mq(Devices.tablet)}{
    grid-template-columns: 1fr;
  }
`;
export const HeaderCol = styled.div`
  
  :nth-of-type(2) {
    display: flex;
    justify-content: center;
    color: red;
  }

  :nth-of-type(3) {
    display: flex;
    justify-content: end;
    align-items: start;
  }

  ${mq(Devices.desktop)}{
    :nth-of-type(1) {
      margin-bottom: 15px;
    }
    :nth-of-type(2) {
      grid-row-start: 1;
      grid-column: 1 / span 2;
      margin-bottom: 15px;
    }
  }

  ${mq(Devices.tablet)}{
    :nth-of-type(1) {
      margin-bottom: 15px;
    }
    :nth-of-type(2) {
      grid-row-start: 1;
      grid-column: 1 ;
      margin-bottom: 15px;
    }
  }
`;

export const CardContent = styled.div`
  height: 340px;
  position: relative;
`;

export const LegendContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  
  ${mq(Devices.tablet)}{
    flex-direction: unset;
    justify-content: space-around;
  }
`;

export const LegendItem = styled.div<{ color: string; active: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;  
  cursor:pointer;

  div {
    width: 40px;
    height: 20px;
    border-radius: 100px;
    background: ${(props) => (props.active ? props.color : '#c0c0c0')};
    content: ' ';    
  }

  span {
    font-size: 16px;
    color: ${(props) => props.color};
  }
`;

export const CSVButton = styled.button`
  font-weight: 500;
  color: #fff;
  background: #2a848e;
  font-size: 16px;
  padding: 10px 20px;
  border-radius: 100px;
  margin-left: auto;
`;

export const ContentOverlay = styled.div`
  padding-top: 40px;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-rows: 7fr 1fr;
  z-index: 2;
  pointer-events: none;
  span {
    font-size: 16px;
    font-weight: 500;
  }
`;

export const GraphProcentage = styled.div`
  padding: 20px 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const GraphText = styled.div<{ color: string }>`
  position: absolute;
  left: 10%;
  top: 0;
  width: 80%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;

  h3 {
    font-size: 50px;
    font-weight: 700;
    color: ${(props) => props.color};
    text-align: center;
  }

  svg {
    height: 24px;
    path {
      fill: ${(props) => props.color};
    }
  }
`;

export const GraphDate = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const GraphDay = styled.span<{ future: boolean }>`
  color: ${(props) => (props.future ? 'red' : 'unset')};
`;

export const GraphContent = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  position: relative;
  height: 100%;
`;

export const MainGraph = styled.div`
  position: relative;
`;

export const ProjectionContainer = styled.div`
  position: relative;
`;
